import { Metamodel } from '../base/model';
import { IModel, IAttribute } from '../base/annotation';
import { ModelConstants } from '../model-constants';
import { TabularTypeDataset } from './tabular-type.dataset';
import { SnowflakeLinkedService } from '../linkedservice/snowflake.linkedservice';
import { shellStringResources as stringResources } from '../../Resources/ShellStringResources';
import { format, getConnectorV1Name, sanitizeAndFormatString, stringIsNullOrEmpty } from '../../shared/utils/string.util';
import { ConnectionKind } from '../../constants/linkedservice-constants';
import { isTridentInIframe } from '../../shared/utils/iframe.utils';

@Metamodel.model({
    name: ModelConstants.snowflakeDataset,
    disabled: isTridentInIframe(),
    display: [
        format(stringResources.ModelName_DatasetTemplate, getConnectorV1Name(stringResources.Snowflake_DisplayText)),
        format(stringResources.ModelName_DatasetsTemplate, getConnectorV1Name(stringResources.Snowflake_DisplayText))
    ],
    constraints: {
        linkedService: {
            model: SnowflakeLinkedService.MODEL // Linked service redefined
        }
    }
})
export class SnowflakeTableDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public static DATABASE: IAttribute;

    @Metamodel.attribute({
        display: stringResources.Database,
        templatable: true,
        association: 'DATABASE',
        constraint: {
            validator: (dataset: SnowflakeTableDataset, database: string) => {
                if (
                    dataset.linkedService?.tridentConnectionKind === ConnectionKind.SNOWFLAKE &&
                    stringIsNullOrEmpty(database)
                ) {
                    return [
                        {
                            context: dataset,
                            messageType: 'missing',
                            message: () =>
                                sanitizeAndFormatString(
                                    stringResources.RequiredTemplate,
                                    stringResources.Database
                                )
                        }
                    ];
                }
                return undefined;
            }
        }
    })
    public database?: string;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = true;
    }
}
